import React, {useState, useEffect, useCallback} from 'react';
import Button from 'react-bootstrap/Button';
import {useRedux} from "../../../hooks";
import {Label, Row,
    Offcanvas,
    OffcanvasHeader,
    OffcanvasBody
} from 'reactstrap';
import 'emojionearea/dist/emojionearea';
import 'emojionearea/dist/emojionearea.css';
import InputText from "../../../components/InputText";
import InputSwitch from "../../../components/InputSwitch";
import {
    hideRightModalSaleCustomer,
    onSendDataSaleCustomer
} from "../../../redux/Sale/Customer/actions";
import '../../../i18/config';
import {useTranslation} from "react-i18next";
import SimpleBar from 'simplebar-react';

import {
    Formik,
    Form,
    Field
} from 'formik';
import {CustomerType} from "../../../redux/Sale/Customer/types";
import {SaleCustomerValidatorSchema} from "./validator";
import InputEmojiArea from "../../../components/InputEmojiArea";
import ButtonSpinner from "../../../components/ButtonSpinner";
import InputPhone from "../../../components/InputPhone";
import {ContentPeerUserType} from "../../../redux/Content/PeerUser/types";
import PeerUserAvatarItem from "../../Content/PeerUser/PeerUserAvatarItem";

const RightModal = () => {

    const { t } = useTranslation(['common']);

    const { dispatch, useAppSelector } = useRedux();

    const {
        saleCustomerState,
        isSending
    } = useAppSelector(state => ({
        saleCustomerState: state.SaleCustomer,
        isSending: state.SaleCustomer.isSending
    }));

    const uuid = saleCustomerState.selectedItem.uuid || null;

    const [formValues, setFormValues] = useState<CustomerType>(saleCustomerState.selectedItem);

    useEffect(() => {
        setFormValues(saleCustomerState.selectedItem);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uuid]);

    const handleClose = useCallback(() => dispatch(hideRightModalSaleCustomer()),[dispatch]);

    const onDataSubmit = useCallback((formData:CustomerType) => {
        let data: any = {};

        if (formData.name) {
            data["name"] = formData.name;
        }
        if (formData.order) {
            data["order"] = formData.order;
        }

        if (formData.description) {
            data["description"] = formData.description;
        }

        if (formData.phone) {
            data["phone"] = formData.phone;
        }

        if (formData.email) {
            data["email"] = formData.email;
        }

        data["enabled"] = formData.enabled;

        if (uuid) {
            data["uuid"] = uuid;
        }

        let params: CustomerType = {
            uuid: data.uuid && data.uuid,
            enabled: data.enabled ? data.enabled : false,
            name: data.name && data.name,
            order: data.order && data.order,
            email: data.email && data.email,
            phone: data.phone && data.phone,
            description: data.description && data.description
        };

        dispatch(onSendDataSaleCustomer(params));

    },[dispatch, uuid]);

    return (
        <>
                <Offcanvas
                    direction="end"
                    isOpen={saleCustomerState.rightModalShow}
                    id="saleCustomerEdit"
                    toggle={handleClose}
                >
                <Formik
                    enableReinitialize={true}
                    initialValues={formValues}
                    validationSchema={SaleCustomerValidatorSchema}
                    onSubmit={(values, actions) => {
                        onDataSubmit(values);
                        actions.setSubmitting(false);
                    }}
                >
                    {({ errors, touched, setFieldValue, getFieldProps, isSubmitting, isValidating }) => (
                    <Form noValidate={true} className="customValidation">
                        <OffcanvasHeader className="bg-light" toggle={handleClose}>
                            {t('customer:'+saleCustomerState.modalEditTitle)}
                        </OffcanvasHeader>
                        <OffcanvasBody className="p-0 overflow-hidden">
                            <SimpleBar style={{height: 'calc(100vh - 140px)'}}>
                                <div className="p-4">

                            <Row>
                                <div className="d-flex">
                                    <div className="ms-1 mb-3 d-flex flex-column align-items-center me-5">
                                        <Field
                                            id="form-enabled-input"
                                            placeholder={t('common:active')}
                                            name="enabled"
                                            component={InputSwitch}
                                            value = {getFieldProps('enabled').value}
                                            onChange={(enabled:boolean) => {
                                                setFieldValue('enabled', !getFieldProps('enabled').value);
                                            }}
                                            required={false}
                                        />
                                    </div>
                                </div>
                            </Row>
                            <Row>
                                <div className={ "mb-3"+ (touched.name ? " was-validated" : '')}>
                                    <Label className="form-label" htmlFor="form-name-input">{t('common:name')}</Label>
                                    <Field
                                        id="form-name-input"
                                        name="name"
                                        placeholder={t('common:enterName')}
                                        component={InputText}
                                        value = {getFieldProps('name').value}
                                        onChange={(name:string) => {
                                            setFieldValue('name', name);
                                        }}
                                        className={errors.name && touched.name && 'form-control is-invalid'}
                                    />
                                    {errors.name && touched.name ? (
                                        <div className="invalid-feedback">
                                            {t('validator:'+errors.name)}
                                        </div>
                                    ) :  touched.name && !errors.name ?
                                        <div className="valid-feedback">
                                            {t('common:looksGood')}
                                        </div>
                                        : ''
                                    }
                                </div>
                            </Row>
                                    {(formValues?.peerUsers || []).length>0 &&
                                        <Row>
                                            <div className={ "mb-3"}>
                                                <div className="d-flex flex-row flex-wrap avatar-group">
                                                    {formValues.peerUsers.map((peerUser: ContentPeerUserType, key: number) => (
                                                        <PeerUserAvatarItem item={peerUser} key={'peerUser_' + peerUser.uuid}/>
                                                    ))}
                                                </div>
                                            </div>
                                        </Row>
                                    }
                            <Row>
                                <div className={ "mb-3"+ (touched.order ? " was-validated" : '')}>
                                    <Label className="form-label" htmlFor="form-order-input">{t('common:order')}</Label>
                                    <Field
                                        id="form-order-input"
                                        name="order"
                                        placeholder={t('common:enterOrder')}
                                        component={InputText}
                                        value = {getFieldProps('order').value}
                                        onChange={(order:string) => {
                                            setFieldValue('order', order);
                                        }}
                                        className={errors.order && touched.order && 'form-control is-invalid'}
                                    />
                                    {errors.order && touched.order ? (
                                        <div className="invalid-feedback">
                                            {t('validator:'+errors.order)}
                                        </div>
                                    ) :  touched.order && !errors.order ?
                                        <div className="valid-feedback">
                                            {t('common:looksGood')}
                                        </div>
                                        : ''
                                    }
                                </div>
                            </Row>
                                    <Row>
                                        <div className={ "mb-3"+ (touched.phone ? " was-validated" : '')}>
                                            <Label className="form-label" htmlFor="form-phone-input">{t('user:phone')}</Label>
                                            <Field
                                                id="form-phone-input"
                                                name="phone"
                                                placeholder={t('user:enterPhone')}
                                                component={InputPhone}
                                                value = {getFieldProps('phone').value}
                                                onChange={(phone:string) => {
                                                    setFieldValue('phone', phone);
                                                }}
                                                inputClassName={errors.phone && touched.phone ? 'form-control is-invalid' : "form-control"}
                                            />
                                            {errors.phone && touched.phone ? (
                                                <div className="invalid-feedback">
                                                    {t('validator:'+errors.phone)}
                                                </div>
                                            ) :  touched.phone && !errors.phone ?
                                                <div className="valid-feedback">
                                                    {t('common:looksGood')}
                                                </div>
                                                : ''
                                            }
                                        </div>
                                    </Row>
                                    <Row>
                                        <div className={ "mb-3"+ (touched.email ? " was-validated" : '')}>
                                            <Label className="form-label" htmlFor="form-email-input">E-mail</Label>
                                            <Field
                                                id="form-email-input"
                                                name="email"
                                                placeholder={t('user:enterEmail')}
                                                component={InputText}
                                                value = {getFieldProps('email').value}
                                                onChange={(order:string) => {
                                                    setFieldValue('email', order);
                                                }}
                                                className={errors.email && touched.email && 'form-control is-invalid'}
                                            />
                                            {errors.email && touched.email ? (
                                                <div className="invalid-feedback">
                                                    {t('validator:'+errors.email)}
                                                </div>
                                            ) :  touched.email && !errors.email ?
                                                <div className="valid-feedback">
                                                    {t('common:looksGood')}
                                                </div>
                                                : ''
                                            }
                                        </div>
                                    </Row>
                                    <Row>
                                        <div className="mb-3">
                                            <Label className="form-label" htmlFor="form-description-input">{t('common:description')}</Label>
                                            <div className="textAreaEmojiBlock">
                                                <Field
                                                    id="form-description-input"
                                                    name="description"
                                                    component={InputEmojiArea}
                                                    value = {getFieldProps('description').value}
                                                    onChange={(text:string) => {
                                                        setFieldValue('description', text);
                                                    }}
                                                    required={false}
                                                    placeholder={t('common:enterDescription')}
                                                />
                                            </div>
                                        </div>
                                    </Row>
                                </div>
                            </SimpleBar>

                        </OffcanvasBody>
                        <div className="offcanvas-footer border-top p-3 text-center position-sticky bottom-0">
                            <div className="d-flex flex-row flex-nowrap gap-2">
                            <Button variant="light" onClick={handleClose} className="w-100">
                                {t('common:close')}
                            </Button>
                            <Button variant="primary"
                                    type="submit"
                                    disabled={isSending}
                                    className="btn btn-primary w-100 chat-send waves-effect waves-light"
                            >
                                {t('common:save')}
                                {isSending &&
                                    <ButtonSpinner/>
                                }
                            </Button>
                            </div>
                        </div>
                    </Form>
                        )}
                </Formik>

                </Offcanvas>
        </>
    );
}

export default RightModal;